var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.5 0L5.51733 2.98265L6.41336 3.87871L7.86634 2.42572V5.9653H9.13366V2.42572L10.5866 3.87871L11.4827 2.98265L8.5 0ZM2.98267 5.51735L0 8.5L2.98267 11.4827L3.87871 10.5866L2.42574 9.13367H5.96535V7.86633H2.42574L3.87871 6.41333L2.98267 5.51735ZM14.0173 5.51735L13.1213 6.41333L14.5743 7.86633H11.0347V9.13367H14.5743L13.1213 10.5866L14.0173 11.4827L17 8.5L14.0173 5.51735ZM7.86634 11.0346V14.5743L6.41336 13.1213L5.51733 14.0173L8.5 17L11.4827 14.0173L10.5866 13.1213L9.13366 14.5743V11.0346H7.86634Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveicon);
export default __webpack_public_path__ + "static/media/moveicon.77788d882c7928f895010f9b1b25db0b.svg";
export { ForwardRef as ReactComponent };